// extracted by mini-css-extract-plugin
module.exports = {"app":"_0fce717cdb--app--I9Hak","fake_header":"_0fce717cdb--fake_header--WIF_r","shadow":"_0fce717cdb--shadow--nKUo1"};